import { useEffect } from 'react';
import lazyLoader from '@deliveroo/consumer-component-library/utils/lazyLoader';

const useLazyLoad = ({ isVisible, setVisibleState, containerRef }) =>
  useEffect(
    () => {
      if (!isVisible) {
        const refEl = containerRef.current;
        if (lazyLoader.isSupported) {
          lazyLoader.observe(refEl, () => setVisibleState({ isVisible: true }));
          return () => lazyLoader.unobserve(refEl);
        }
        setVisibleState({ isVisible: true });
      }
      return undefined;
    },
    [isVisible, setVisibleState, containerRef],
  );

export default useLazyLoad;
